import React from 'react';
import galleryStyles from './FanFeedGallery.scss'
import HLSPlayer from '../../HLSPlayer';
import classNames from 'classnames'
import { FormattedDate, FormattedTime } from 'react-intl';
import NameFormatter from '../../NameFormatter';
import ConfirmMessage from '../../ConfirmMessage'

export class FanFeedGallery extends React.Component {
    constructor({ selected, records }) {
      super()
      this.state = {
        selected: records.indexOf(records.find(item => item.id === selected)),
        dialogOpen: false,
        dialogAction: undefined,
        dialogLabel: '',
        message: undefined
      }
    }
    prevItem(){
      const { records, onSelectItem } = this.props
      onSelectItem(records[Math.max(this.state.selected - 1, 0)].id)
    }
    nextItem(){
      const { records, onSelectItem } = this.props
      const nextItem = this.state.selected + 1 >= this.props.records.length ? 0 : this.state.selected + 1
      onSelectItem(records[nextItem].id)
    }
    render(){
  
      const { onClose, records, onDeclineItem, onAcceptItem, onDeleteItem, authorRecords } = this.props
      const { id, likes_count, image, tags, createdBy = {}, createDate, video_url, status, text } = records[this.state.selected] || {}
      
      return (image ? <div className={classNames(galleryStyles.gallery, galleryStyles[status], authorRecords.length ? galleryStyles.hasAuthorPictures : undefined)}>
        <ConfirmMessage open={!!this.state.dialogAction}
          label={this.state.dialogLabel || ''}
          onConfirm={() => { this.state.dialogAction(id, this.state.message); if (this.state.dialogAction !== onDeleteItem) this.nextItem() }}
          onClose={() => this.setState({ dialogAction: undefined })}
          message={<input placeholder='write the reason to decline' className={galleryStyles.declineReasonInput}  value={ this.state.message } type="text" onChange={(e) => this.setState({message: e.target.value})} />}
                />
          <button className={galleryStyles.closeButton} onClick={ onClose }>x</button>
          <div className={galleryStyles.arrows}>
            <button onClick={ () => this.prevItem() }>◀</button>
            <button onClick={ () => this.nextItem() }>▶</button>
          </div>
          <div className={ galleryStyles.buttons }>
            <button disabled={status === 'rejected'} onClick={() => {
              // onDeclineItem(id)
              // this.nextItem();
                  this.setState({ dialogAction: onDeclineItem, dialogLabel: 'The post will be declined' })
            }}>decline</button>
            <button disabled={status === 'accepted'} onClick={() => {
              onAcceptItem(id);
              this.nextItem();
                  // this.setState({ dialogAction: onAcceptItem, dialogLabel: 'The post will be published' })
            }}>approve</button>
          </div>
        {video_url
          ? <div className={galleryStyles.videoContainer}>
              <HLSPlayer controls autoPlay value={{ url: video_url }} />
            </div>
          : <img src={image._url} />
        }
        <ul className={galleryStyles.authorLastPics}>
          {authorRecords.map(item => <li key={item.id}>
            <img style={{
              filter: `brightness(${item.id === id ? 0.4 : 1});`,
              border: `5px solid ${item.status === 'in_review' ? 'transparent' : item.status === 'accepted' ? 'green' : 'red'}`
            }} src={item.image._medium} />
          </li>) }
        </ul>
          <div className={ galleryStyles.info }>
            <span>{ likes_count }</span>
            <span>{ tags.map(tag => `#${tag}`).join(', ') }</span>
            <span style={{margin: 16}}>
              <FormattedDate value={createDate} />,&nbsp;
              <FormattedTime value={createDate} />
            </span>
            <NameFormatter user={createdBy}></NameFormatter>
          </div>
          <div className={galleryStyles.descriptionText}>{ (text || '').split(/\n/).map((str, index) => <p key={index}>{str}</p>) }</div>
          <button className={galleryStyles.deleteButton} onClick={ () => {
                this.setState({ dialogAction: onDeleteItem, dialogLabel: 'The post will be deleted' })
              }}>delete</button>
        </div> : null)
    }
  }


// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedPostList/FanFeedGallery.jsx